import Box from "@mui/material/Box";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import Button from "designSystem/components/button/Button";
import { grey } from "designSystem/styles/color";
import FlexColumn from "designSystem/components/flex/FlexColumn";
import FlexRowCenter from "designSystem/components/flex/FlexRowCenter";
import CentricIcon from "designSystem/components/icon/CentricIcon";
import PaneHeader from "designSystem/components/pane/PaneHeader";
import Placeholder from "designSystem/components/placeholder/Placeholder";
import React from "react";
import { HeaderCallbacks } from "src/Chat/types";
import MSTeamsIcon from "../icon/MSTeamsIcon";
import { useMSTeamsStore } from "./MSTeamsStore";

const JoinMSTeams: React.FunctionComponent = () => {
	const {
		closeRightPane,
		handleOnBack,
		signIn,
	} = useMSTeamsStore();

	return (
		<FlexColumn>
			<PaneHeader
				back={false}
				onBack={handleOnBack}
				onClose={closeRightPane}
				titleRes="MSTeams"
			/>
			<FlexRowCenter
				flexGrow={1}
				justifyContent="center"
				px={3}
			>
				<Placeholder
					subtitleMargin={6}
					subtitleProps={{ res: "SignInToMSTeamsPlaceholderText" }}
					titleProps={{ res: "SignInToMSTeamsPlaceholderTitle" }}
				>
					{{
						actions:
							<Button
								design="primary"
								onClick={signIn}
								res="SignInToMSTeamsButton"
							/>
						,
						image:
							<Box>
								<Box component="span" height={63}>
									<CentricIcon removeFillColor style={{ fontSize: 63, verticalAlign: "middle" }} />
								</Box>
								<Box component="span" height={24}>
									<ArrowForwardIcon style={{ fontSize: 24, position: "relative", top: "0", left: "12px", color: grey[300] }} />
								</Box>
								<Box component="span" height={24}>
									<ArrowBackIcon style={{ fontSize: 24, position: "relative", top: "20px", left: "-12px", color: grey[300] }} />
								</Box>
								<Box component="span" height={45}>
									<MSTeamsIcon style={{ fontSize: 56, verticalAlign: "middle" }} />
								</Box>
							</Box>,
					}}
				</Placeholder>
			</FlexRowCenter>
		</FlexColumn>
	);
};

export default JoinMSTeams;